import ProductFamilyDetails from "./ProductFamilyDetails";

export default ProductFamilyDetails;
